import { withResolvePaths } from "../Controls/withResolvePaths";
import { withViewModelSelect } from "../Controls/withViewModelSelect";
import { PushInstance } from "../Controls/Internals/ControlContexts/PathContexts/PushInstance";
import { trackAction } from "../Controls/Internals/Metrics/MetricsProvider";
import { addInstance, setToModel, setToModelBatch } from "../Engine/ActionCreators/AllActionCreators";
import { ModelHunk } from "../Engine/Core/ModelStoring/ModelHunk";

import { withControlDispatcher } from "./CustomControlsHelpers/CustomControlControlDispatcher";
import { withModelAccessor } from "./CustomControlsHelpers/CustomControlModelAccessor";

export const customizationHelpers = {
    PushInstance: PushInstance,
    withResolvePaths: withResolvePaths,
    addInstance: addInstance,
    trackAction: trackAction,
    withViewModelSelect: withViewModelSelect,
    setToModel: setToModel,
    setToModelBatch: setToModelBatch,
    ModelHunk: ModelHunk,
    withModelAccessor: withModelAccessor,
    withControlDispatcher: withControlDispatcher,
};
